import { render, staticRenderFns } from "./MainSidebar.vue?vue&type=template&id=1ad3baee&scoped=true&"
import script from "./MainSidebar.vue?vue&type=script&lang=js&"
export * from "./MainSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MainSidebar.vue?vue&type=style&index=0&id=1ad3baee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad3baee",
  null
  
)

export default component.exports